/*
 * Copyright (c) 2020.
 * kurokeita
 */

import {
    EMAIL_BLACKLIST_LIST_SUCCESS,
    EMAIL_BLACKLIST_UPDATE_SUCCESS
} from "../../../types"

/**
 * @param {*} state
 * @param {*} action
 */
const EmailBlacklistReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state

    switch (action.type) {
        case EMAIL_BLACKLIST_LIST_SUCCESS:
            let emailBlacklistList = action.payload.data.data

            emailBlacklistList.map((emailBlacklist) => {
                let id = emailBlacklist['id']
                state[id] = emailBlacklist
                return true
            });

            return {...state, action}
            
        case EMAIL_BLACKLIST_UPDATE_SUCCESS:
            let id = action.payload.data['id']
            state[id] = action.payload.data
            return {...state, action}
        default:
            return state
    }
}

export {EmailBlacklistReducer}